export const category = {
  category: {
    searchFacetFilter: 'Enter {{facet}}'
  
  },
};
